var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[{'table-column_full-width': _vm.cellFullWidth},'table-column',{'table-column_border': _vm.cellBorder} ],style:({background: _vm.backgroundColor}),on:{"click":_vm.getCellNumber}},[_vm._t("default",null,{"tough":true})],2)}
var staticRenderFns = []

export { render, staticRenderFns }